import { useEffect } from 'react';

/**
 * @param {{
 *   open: boolean;
 *   title: string;
 *   description?: string;
 *   onClose: () => void;
 *   children: import('react').ReactNode;
 *   footer?: import('react').ReactNode;
 *   size?: 'md' | 'lg' | 'xl';
 *   dismissible?: boolean;
 * }} props
 */
export function Modal({ open, title, description, onClose, children, footer, size = 'md', dismissible = true }) {
  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const onKey = (e) => {
      if (dismissible && e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose, dismissible]);

  if (!open) {
    return null;
  }

  return (
    <div className="modal-backdrop" onClick={dismissible ? onClose : undefined} role="presentation">
      <div
        className={`modal-panel modal-panel--${size}`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
      >
        <header className="modal-header">
          <div>
            <h3 id="modal-title" className="modal-title">
              {title}
            </h3>
            {description ? <p className="muted small modal-description">{description}</p> : null}
          </div>
          {dismissible ? (
            <button type="button" className="modal-close" onClick={onClose} aria-label="Close">
              ×
            </button>
          ) : null}
        </header>
        <div className="modal-body">{children}</div>
        {footer ? <footer className="modal-footer">{footer}</footer> : null}
      </div>
    </div>
  );
}

/**
 * @param {{ onCancel: () => void; onConfirm: () => void; confirmLabel?: string; confirmBusy?: boolean; danger?: boolean }} props
 */
export function ModalConfirmFooter({ onCancel, onConfirm, confirmLabel = 'Confirm', confirmBusy = false, danger = false }) {
  return (
    <>
      <button type="button" className="btn-secondary" onClick={onCancel} disabled={confirmBusy}>
        Cancel
      </button>
      <button
        type="button"
        className={danger ? 'btn-danger' : 'btn-primary'}
        onClick={onConfirm}
        disabled={confirmBusy}
      >
        {confirmBusy ? 'Please wait…' : confirmLabel}
      </button>
    </>
  );
}
